module.exports = "/_next/static/images/3ca27ea1cc5200b0b8e29d6247d2c13b-roxinho-single-md@2x.jpg";